<template>
  <v-content>
    <v-layout>
      <v-container app fluid>
        <v-card
          max-width="480px"
          class="mx-auto px-5 py-2 my-5"
          justify="center"
          align="center"
        >
          <v-col class="math">
            <v-row class="heading"><h2>BMR Calculator</h2></v-row>
            <v-row dense>
              <v-form>
                <v-select
                  :items="formulas"
                  label="Formula"
                  v-model="selected"
                  item-text="name"
                ></v-select>
                <v-text-field
                  v-model="weight"
                  label="Weight (in KG)"
                ></v-text-field>
                <v-text-field
                  v-model="height"
                  label="Height (in CM)"
                ></v-text-field>
                <v-text-field v-model="age" label="Age"></v-text-field>

                <v-select
                  align="center"
                  :items="activityLevel"
                  label="Activity Level"
                  v-model="selectedAL"
                  item-text="name"
                ></v-select>
                <v-radio-group v-model="sex" row>
                  <v-radio label="Male" value="Male"></v-radio>
                  <v-radio label="Female" value="Female"></v-radio>
                </v-radio-group>
                <v-btn text @click="calculate" class="ma-2">Calculate</v-btn>
                <v-btn text @click="reset" class="ma-2">Reset</v-btn>
              </v-form>
            </v-row>
            <v-col>
              <v-subheader>Approx. BMR: {{ this.BMR }}</v-subheader>
              <v-subheader
                >Approx. Lean Body Mass: {{ this.lbmValue }}</v-subheader
              ><v-subheader
                >Approx. Maintenance Calories: {{ this.maintCals }}</v-subheader
              >
            </v-col>
          </v-col>
        </v-card>
      </v-container>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  data: () => ({
    weight: null,
    height: null,
    age: null,
    BMR: null,
    sex: null,
    lbmValue: null,
    maintCals: null,
    selected: "Harris-Benedict Equation",
    formulas: [
      {
        name: "Harris-Benedict Equation",
        maleWeightMulti: 13.397,
        maleHeightMulti: 4.799,
        maleAgeMulti: 5.677,
        maleOffset: 0,
        femaleWeightMulti: 9.247,
        femaleHeightMulti: 2.098,
        femaleAgeMulti: 4.33,
        femaleOffset: 0,
      },
      {
        name: "Mifflin-St Jeor Equation",
        maleWeightMulti: 10,
        maleHeightMulti: 6.25,
        maleAgeMulti: 5,
        maleOffset: 5,
        femaleWeightMulti: 10,
        femaleHeightMulti: 6.25,
        femaleAgeMulti: 5,
        femaleOffset: -161,
      },
      {
        name: "Katch-McArdle Equation",
        offset: 370,
        multiplier: 21.6,
      },
    ],
    selectedAL: "None/Disable",
    activityLevel: [
      {
        name: "None/Disable",
        multiplier: 1,
      },
      {
        name: "Sedentary (little to no exercise)",
        multiplier: 1.2,
      },
      {
        name: "Slightly Active (1-2 days/week)",
        multiplier: 1.375,
      },
      {
        name: "Moderately Active (2-3 days/week)",
        multiplier: 1.55,
      },
      {
        name: "Quite Active (4-5 days/week)",
        multiplier: 1.725,
      },
      {
        name: "Extremely Active (2x daily training)",
        multiplier: 1.9,
      },
    ],
  }),
  methods: {
    calculate() {
      console.log(this.selected);
      this.lbm();
      switch (this.selected) {
        case "Harris-Benedict Equation":
          this.hbEq();
          this.activityCalc();
          this.round();
          break;
        case "Mifflin-St Jeor Equation":
          this.msEq();
          this.activityCalc();
          this.round();
          break;
        case "Katch-McArdle Equation":
          this.kmEq();
          this.activityCalc();
          this.round();
          break;
      }
    },
    reset() {
      this.lbmValue = null;
      this.weight = null;
      this.height = null;
      this.age = null;
      this.BMR = null;
      this.sex = null;
      this.maintCals = null;
    },
    lbm() {
      if (this.sex == "Male") {
        this.lbmValue = 0.407 * this.weight + 0.267 * this.height - 19.2;
      } else {
        this.lbmValue = 0.252 * this.weight + 0.473 * this.height - 48.3;
      }
    },

    hbEq() {
      let i = 0;
      if (this.sex == "Male") {
        this.BMR =
          this.formulas[i].maleWeightMulti * this.weight +
          this.formulas[i].maleHeightMulti * this.height -
          this.formulas[i].maleAgeMulti * this.age;
      } else {
        this.BMR =
          this.formulas[i].femaleWeightMulti * this.weight +
          this.formulas[i].femaleHeightMulti * this.height -
          this.formulas[i].femaleAgeMulti * this.age;
      }
    },
    msEq() {
      let i = 1;
      if (this.sex == "Male") {
        this.BMR =
          this.formulas[i].maleWeightMulti * this.weight +
          this.formulas[i].maleHeightMulti * this.height -
          this.formulas[i].maleAgeMulti * this.age +
          this.formulas[i].maleOffset;
      } else {
        this.BMR =
          this.formulas[i].femaleWeightMulti * this.weight +
          this.formulas[i].femaleHeightMulti * this.height -
          this.formulas[i].femaleAgeMulti * this.age +
          this.formulas[i].femaleOffset;
      }
    },
    kmEq() {
      let i = 2;
      this.BMR =
        this.formulas[i].offset + this.formulas[i].multiplier * this.lbmValue;
    },
    round() {
      this.lbmValue = Math.round(this.lbmValue);
      this.BMR = Math.round(this.BMR);
      this.maintCals = Math.round(this.maintCals);
    },
    activityCalc() {
      for (let i = 0; i < 6; i++) {
        if (this.selectedAL == this.activityLevel[i].name) {
          this.maintCals = this.BMR * this.activityLevel[i].multiplier;
          console.log(this.maintCals);
        }
      }
    },
  },
};
</script>

<style></style>
